module.exports = "<button class=\"btn btn-primary btn-sm\" (click)=\"printOrder()\">Print</button>\n"


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/print-pdf/print-pdf.component.html
// module id = ../../../../../src/app/print-pdf/print-pdf.component.html
// module chunks = main